import api from './axios';
import { Offer } from '../types';

export const getOffers = async (admin = false): Promise<Offer[]> => {
  const response = await api.get<Offer[]>(`/offers${admin ? '?admin=true' : ''}`);
  return Array.isArray(response.data) ? response.data : [response.data];
};

export const getOffer = (id: number) =>
  api.get<Offer>(`/offers/${id}`).then(r => r.data);

export const createOffer = (data: any) =>
  api.post<Offer>('/offers', data).then(r => r.data);

export const updateOfferStatus = async (id: number, status: string): Promise<Offer> => {
  const token = localStorage.getItem('token');
  const response = await api.patch<Offer>(
    `/offers/${id}/status`,
    null,
    {
      params: { status },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    }
  );
  return response.data;
};

export const deleteOffer = (id: number) =>
  api.delete(`/offers/${id}`);

export const updateOffer = (id: number, data: any) =>
    api.put<Offer>(`/offers/${id}`, data).then(r => r.data);

export const getOfferRevisions = async (id: number): Promise<any[]> => {
    const res = await api.get(`/offers/${id}/revisions`);
    return res.data;
};